import axios from "axios";

export function setup() {
  axios.defaults.headers.common.Accept = "application/json";
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.baseURL = process.env.ELIG_FIBRE_API_HOST;

  axios.interceptors.request.use(async r => r);
}
